import { render, staticRenderFns } from "./DocumentHistory.vue?vue&type=template&id=b0f4777c&scoped=true"
import script from "./DocumentHistory.vue?vue&type=script&lang=js"
export * from "./DocumentHistory.vue?vue&type=script&lang=js"
import style0 from "./DocumentHistory.vue?vue&type=style&index=0&id=b0f4777c&scoped=true&lang=css"
import style1 from "./DocumentHistory.vue?vue&type=style&index=1&id=b0f4777c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4777c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f4777c')) {
      api.createRecord('b0f4777c', component.options)
    } else {
      api.reload('b0f4777c', component.options)
    }
    module.hot.accept("./DocumentHistory.vue?vue&type=template&id=b0f4777c&scoped=true", function () {
      api.rerender('b0f4777c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/DocumentHistory.vue"
export default component.exports